import { render, staticRenderFns } from "./addAndModiify.vue?vue&type=template&id=5c4e5a52&scoped=true&"
import script from "./addAndModiify.vue?vue&type=script&lang=js&"
export * from "./addAndModiify.vue?vue&type=script&lang=js&"
import style0 from "./addAndModiify.vue?vue&type=style&index=0&id=5c4e5a52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e5a52",
  null
  
)

export default component.exports